export default __webpack_public_path__ + "CircularCustCapNum-BlackItalic.41b31c484e920c2821ed419124f3040a.woff";